import { ApiRequest, ApiResponse, fetchDataFromAPITyped } from './api-requests';
import type {
    PricingGroup,
    PricingGroupListResponse,
    CreatePricingGroupPayload,
    UpdatePricingGroupPayload,
} from '../models/pricing-group-model';

export const getPricingGroups = async (): Promise<ApiResponse<PricingGroupListResponse | null>> => {
    const apiQuery: ApiRequest = {
        route: 'pricing-groups',
        request: { method: 'GET', entity: 'pricing_group', body: undefined },
    };
    return fetchDataFromAPITyped(apiQuery);
};

export const getPricingGroupDetail = async (groupId: string): Promise<ApiResponse<PricingGroup | null>> => {
    const apiQuery: ApiRequest = {
        route: `pricing-groups/${groupId}`,
        request: { method: 'GET', entity: 'pricing_group', body: undefined },
    };
    return fetchDataFromAPITyped(apiQuery);
};

export const createPricingGroup = async (payload: CreatePricingGroupPayload): Promise<ApiResponse<PricingGroup | null>> => {
    const apiQuery: ApiRequest = {
        route: 'pricing-groups',
        request: { method: 'POST', entity: 'pricing_group', body: payload },
    };
    return fetchDataFromAPITyped(apiQuery);
};

export const updatePricingGroup = async (groupId: string, payload: UpdatePricingGroupPayload): Promise<ApiResponse<PricingGroup | null>> => {
    const apiQuery: ApiRequest = {
        route: `pricing-groups/${groupId}`,
        request: { method: 'PUT', entity: 'pricing_group', body: payload },
    };
    return fetchDataFromAPITyped(apiQuery);
};

export const deletePricingGroup = async (groupId: string): Promise<ApiResponse<any>> => {
    const apiQuery: ApiRequest = {
        route: `pricing-groups/${groupId}`,
        request: { method: 'DELETE', entity: 'pricing_group', body: undefined },
    };
    return fetchDataFromAPITyped(apiQuery);
};

export const addPricingGroupMember = async (groupId: string, email: string): Promise<ApiResponse<any>> => {
    const apiQuery: ApiRequest = {
        route: `pricing-groups/${groupId}/members`,
        request: { method: 'POST', entity: 'pricing_group_member', body: { user_email: email } },
    };
    return fetchDataFromAPITyped(apiQuery);
};

export const revokePricingGroupMember = async (groupId: string, memberId: string): Promise<ApiResponse<any>> => {
    const apiQuery: ApiRequest = {
        route: `pricing-groups/${groupId}/members/${memberId}`,
        request: { method: 'DELETE', entity: 'pricing_group_member', body: undefined },
    };
    return fetchDataFromAPITyped(apiQuery);
};

export const restorePricingGroupMember = async (groupId: string, memberId: string): Promise<ApiResponse<any>> => {
    const apiQuery: ApiRequest = {
        route: `pricing-groups/${groupId}/members/${memberId}/restore`,
        request: { method: 'PUT', entity: 'pricing_group_member', body: undefined },
    };
    return fetchDataFromAPITyped(apiQuery);
};
